import {useEffect, useState} from "react";
import {animated, useSpring} from "@react-spring/web";
import styles from "../marketing.module.scss";
import sec10_img01 from "../../../../resources/img/Events/Marketing/sec10_img01.png";
import sec10_img02 from "../../../../resources/img/Events/Marketing/sec10_img02.png";
import sec10_img03 from "../../../../resources/img/Events/Marketing/sec10_img03.png";
import sec10_img04 from "../../../../resources/img/Events/Marketing/sec10_img04.png";
import sec10_img05 from "../../../../resources/img/Events/Marketing/sec10_img05.png";
import sec10_img06 from "../../../../resources/img/Events/Marketing/sec10_img06.png";

export const Section10 = (props) => {
    const [frame, setFrame] = useState(0)
    const spring = useSpring({ x: frame })

    useEffect(() => {
        if (!props.ranges?.length || props.ranges[0].length < 2) return
        const currentFrame = props.run(props)
        // console.log(currentFrame)
        setFrame(currentFrame)
    }, [props.pageYOffset, props.innerHeight])

    const imageUp = {
        translateY: spring.x.to({
            range: [0, 0.85, 1],
            output: [0, 0, -10]
        }).to(x => `${x}vh`)
    }

    return (
        <animated.div className={styles['animation-container']} style={{
            opacity: spring.x.to({
                range: props.section.opacityRange as number[],
                output: props.section.opacityOutput as number[]
            }).to(x => x),
        }}>
            <animated.div className={`${styles.sec} ${styles.sec10} ${styles.rel} ${frame > 0.135 && styles['dark-gray']}`} style={{
                opacity: spring.x.to({
                    range: [0, 0.85, 1],
                    output: [1, 1, 0]
                }).to(x => x),
            }}>
                <animated.a href="#" className={`${styles.sec10__link} ${styles['z-index-10']}`} target="_blank" style={{
                    opacity: spring.x.to({
                        range: [0, 0.1, 1],
                        output: [0, 1, 1]
                    }).to(x => x),
                    translateY: spring.x.to({
                        range: [0, 0.1, 0.85, 1],
                        output: [10, 0, 0, -10]
                    }).to(x => `${x}vh`)
                }}>
                    <p className={`${styles.sec10__link__font01} ${styles.marginDel}`}>빗썸</p>
                    <span className={`${styles.sec10__link__font02} ${styles.notoBold}`}>플러스</span>
                    <p className={`${styles.sec10__link__font03} ${styles.marginDel}`}>bithumb plus</p>
                </animated.a>
                <animated.div className={`${styles.sec10__images} ${frame < 0.25 && styles['no-display']}`} style={{
                    opacity: spring.x.to({
                        range: [0, 0.2, 0.3, 1],
                        output: [0, 0, 1, 1]
                    }).to(x => x),
                }}>
                    <animated.img src={sec10_img01} className={`${styles.sec10__images__img01} ${styles.ab}`} alt="바구니" style={imageUp} />
                    <animated.img src={sec10_img02} className={`${styles.sec10__images__img02} ${styles.ab} ${frame < 0.85 && styles['sec10__images__img02--on']}`} alt="+DOT +SOL" style={imageUp} />
                    <animated.img src={sec10_img03} className={`${styles.sec10__images__img03} ${styles.ab} ${frame < 0.85 && styles['sec10__images__img03--on']}`} alt="+LN" style={imageUp} />
                    <animated.img src={sec10_img04} className={`${styles.sec10__images__img04} ${styles.ab} ${frame < 0.85 && styles['sec10__images__img04--on']}`} alt="중앙 +" style={imageUp} />
                    <animated.img src={sec10_img05} className={`${styles.sec10__images__img05} ${styles.ab} ${frame < 0.85 && styles['sec10__images__img05--on']}`} alt="+ADA" style={imageUp} />
                    <animated.img src={sec10_img06} className={`${styles.sec10__images__img06} ${styles.ab} ${frame < 0.85 && styles['sec10__images__img06--on']}`} alt="오른쪽 +" style={imageUp} />
                </animated.div>
            </animated.div>
        </animated.div>
    )
}